<template>
  <div id="task-list" class="h-full">
    <!-- タスク一覧 -->
    <vue-perfect-scrollbar :style="{ height: scrollHeight }">

      <div v-if="isEmptyTask" class="w-full h-full flex items-center justify-center">
        <span class="empty-task-test">
          タスクが存在しません
        </span>
    </div>

      <div v-for="(task, index) in tasks" :key="index">        
        <background-task-card :task="task" />
        <vs-divider  class="m-0 p-0" />
      </div>
    </vue-perfect-scrollbar>
    <vs-divider class="m-0 p-0" />

    <!-- ページネーション領域 -->
    <task-manager-pagination-view />
  </div>
</template>

<script>
import BackgroundTaskCard from "./components/BackgroundTaskCard"
import TaskManagerPaginationView from "./TaskManagerPaginationView"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapState } = createNamespacedHelpers("enterpriseBackgroundTaskManager");


export default {
  components: {
    BackgroundTaskCard,
    VuePerfectScrollbar,
    TaskManagerPaginationView
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data () {
    return {
    }
  },
  computed: {
    ...mapState(["tasks"]),
    scrollHeight () {
      return `${this.$store.state.windowHeight - 240}px`
    },
    isEmptyTask(){
      return this.tasks.length === 0
    }
  },
  methods: {
    ...mapActions(["fetchAllTaskList"]),
  },
  async created () {
    await this.fetchAllTaskList();
  }
}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#task-list {
  .task-count {
    padding: 8px;
    border: solid 1px $aisea-dark-gray;
    border-radius: 100%;
  }

  .empty-task-test {
    color: $aisea-gray;
  }
}
</style>